import React, { FC } from 'react';

const Span: FC = (props): JSX.Element => <span {...props} />;

export default Span;
